// extracted by mini-css-extract-plugin
export var modal = "_tu-0";
export var table = "_tu-1";